import { LoaderCircle } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

import { SpinnerProps } from './type'

export function Spinner({ className, ...props }: SpinnerProps) {
  const baseClassName = 'animate-spin text-fintalk'

  return (
    <LoaderCircle {...props} className={twMerge(baseClassName, className)} />
  )
}
